import { render, staticRenderFns } from "./Pay5.vue?vue&type=template&id=8e13bde8&"
import script from "./Pay5.vue?vue&type=script&lang=js&"
export * from "./Pay5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports